import { useMsal } from '@azure/msal-react';
import { Alert, Box, Container } from '@mui/material';
import { useEffect } from 'react';
import { loginRequest } from './requests';

export const AuthRequired = () => {
	const { instance } = useMsal();
	const activeAccount = instance.getActiveAccount();

	useEffect(() => {
		if (!activeAccount) {
			instance
				.loginRedirect(loginRequest)
				.then(result => {
					console.log('result', result);
				})
				.catch(reason => console.error('error', reason));
		}
	}, [instance, activeAccount]);

	return (
		<Box
			flex={1}
			p={1}>
			<Container maxWidth='md'>
				<Alert
					severity='warning'
					title='Authentication Required'>
					This application requires an Authenticated User. <br /> You
					will be redirected to a login page, please wait...
				</Alert>
			</Container>
		</Box>
	);
};
